import IncidentService from '@api/IncidentService';
import LegalLogRecord from '@components/SubmissionTabs/LegalLogRecord';
import LegalReviewForm from '@components/SubmissionTabs/LegalReviewForm';
import ReportHeader from '@components/SubmissionTabs/ReportHeader';
import SubmissionTabs from '@components/SubmissionTabs/SubmissionTabs';
import routes from '@constants/routes';
import { ExpertRole } from '@declarations/common/enums/ExpertRole';
import { UserType } from '@declarations/common/enums/UserType';
import { ReportTypeEnum } from '@declarations/common/reportType';
import useApi from '@hooks/useApi';
import { UserSelectors } from '@store/slices/user';
import { memo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

function IncidentLegalReviewTab() {
  const [searchParams] = useSearchParams();
  const user = useSelector(UserSelectors.user);
  const logRecordRef = useRef<{ refresh(): void }>(null);

  const { data, isLoading, fetch } = useApi({
    method: IncidentService.getById,
    initialData: {} as any,
  });

  useEffect(() => {
    fetch(Number(searchParams.get('id')));
  }, []);

  const handleSave = () => {
    logRecordRef.current?.refresh();
  }
  
  const showForm = user.type === UserType.SuperAdmin || user.expertRole === ExpertRole.LegalReviewer || user.expertRole === ExpertRole.IntegratedReviewer;

  return (
    <>
      <SubmissionTabs active="legal-review" prefix={routes.incidentReportForm} />
      <ReportHeader
        name="Incident"
        createdAt={data.createdAt}
        reportNumber={data.reportNumber}
        riskPoints={data.riskPoints}
        loading={isLoading}
      />
      {showForm && <LegalReviewForm reportType={ReportTypeEnum.Incident} onSave={handleSave} />}
      <LegalLogRecord reportType={ReportTypeEnum.Incident} ref={logRecordRef} />
    </>
  );
}

export default memo(IncidentLegalReviewTab);
